import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getorder:'/teams/order/getshangwuorder/',
  getpsorder:'/teams/order/get_sendorder/',
  createsendorder:'/teams/sendorder/',
  GetInventoryList:'/teams/inventory/getshangwuinventory/'

}
export function Orderdetail (id) {
  return axios({
    url: '/teams/order/'+id+'/',
    method: 'get'
  })
}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getorder (params) {
  return axios({
    url: api.getorder,
    method: 'get',
    params
  })
}
export function getpsorder (params) {
  return axios({
    url: api.getpsorder,
    method: 'get',
    params
  })
}
export function createsendorder (data) {
  return axios({
    url: api.createsendorder,
    method: 'post',
    data
  })
}
export function GetInventoryList (params) {
  return axios({
    url: api.GetInventoryList,
    method: 'get',
    params
  })
}
export function RemoveDiaohuo (obj) {
  return axios({
    url: '/teams/order/removediaohuo/',
    method: 'post',
    data: obj
  })
}
export function Diaohuo (obj) {
  return axios({
    url: '/teams/order/diaohuo/',
    method: 'post',
    data: obj
  })
}
export function Tuihuiorder (obj) {
  return axios({
    url: '/teams/order/tuihuiorder/',
    method: 'post',
    data: obj
  })
}

export function fabusendorder (obj) {
  return axios({
    url: '/teams/sendorder/fabu_sendorder/',
    method: 'post',
    data: obj
  })
}

export function chehuisendorder (obj) {
  return axios({
    url: '/teams/sendorder/chehui_sendorder/',
    method: 'post',
    data: obj
  })
}
export function Delpeisong (id) {
  return axios({
    url: '/teams/sendorder/'+id+'/',
    method: 'delete',
    data: { id }
  })
}



// WEBPACK FOOTER //
// ./src/views/shangwuviews/orderdetail/api.js